export const splitNoteComposerValue = (value: string) => {
	const normalized = value.replace(/\r\n/g, '\n');
	const newlineIndex = normalized.indexOf('\n');
	if (newlineIndex === -1) return { title: normalized, body: '' };

	return {
		title: normalized.slice(0, newlineIndex),
		body: normalized.slice(newlineIndex + 1),
	};
};

export const joinNoteComposerValue = (title: string, body: string) => {
	if (!body) return title;
	return `${title}\n${body}`;
};
